import React from 'react';
import EntryGuidePrintButton from '../EntryGuides/EntryGuidePrintButton';

const SalesContinuousServicePrintButton = ({ serviceId, className }) => (
  <EntryGuidePrintButton
    className={className}
    title="Imprimir"
    onClick={() =>
      window.open(`/ventas/continuous-services/${serviceId}/print`, '_blank', 'noopener,noreferrer')
    }
  />
);

export default SalesContinuousServicePrintButton;
